import React, { useState } from 'react'
import { MDBBtn, MDBInput } from 'mdbreact'
//graphql
import { useMutation } from '@apollo/react-hooks';
import ADD_COMMENT from '../queries/blog/addComment'
import ReCAPTCHA from "react-google-recaptcha";

const AddComment = ({blogID}) => {

    const [ formData, setFormData ] = useState({
        name: '',
        comment: ''
    })

    const [captcha, setCaptcha] = useState(false)

    const [ btn, setBtn ] = useState('leave comment')
    
    const { name, comment } = formData

    const onChange = e => setFormData({...formData, [e.target.name]: e.target.value})

    const [ addComment ] = useMutation(ADD_COMMENT)

    const errorCaptcha = () => setCaptcha(true)
    const recaptchaRef = React.createRef();

    const onSubmit = e => {
        e.preventDefault();
        const recaptchaValue = recaptchaRef.current.getValue();
        if(recaptchaValue !== null && recaptchaValue !== `undefined` && recaptchaValue.length !== 0){
            if(addComment({ variables: { name: name, comment: comment, blog: blogID } })){
                setBtn(
                    <>
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    </>
                )
                setCaptcha(false);
                setTimeout(()=>{
                    setFormData({
                        name: '',
                        comment: ''
                    })
                    setBtn('Leave comment')
                },1200)     
            }
        }
        else{
            errorCaptcha()
        }
    }

    return (
        <>
            <h5 className="h5-responsive mb-5 mt-5 text-uppercase font-weight-bold">
                Leave a comment
            </h5>
            <div className="add-comment-container">
                <form onSubmit={(e)=>onSubmit(e)}>
                    <MDBInput required name="name" style={{ borderRadius: 0, border: `1px solid #000` }} value={name} onChange={(e)=>onChange(e)} type="text" className="w-50" outline label="Your Name"/>
                    <MDBInput required name="comment" style={{ borderRadius: 0, border: `1px solid #000` }} value={comment} onChange={(e)=>onChange(e)} type="textarea" rows="5" className="w-50" outline label="Your Message"/>
                    {captcha && <h6 className="red-text h6-responsive mb-3">
                        You need to verify your identity below.
                    </h6>}
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6Ld_1cEZAAAAAILqFsxD1yNO4cT5UojHRdhBCLEp"
                        onChange={(value)=>{console.log(value); setCaptcha(false);}}
                    />
                    <MDBBtn type="submit" className="ml-0 mt-4 text-capitalize" size="md" color="dark">
                        {btn}
                    </MDBBtn>
                </form>
            </div>
            <div className="add-comment-mobile-container">
                <form onSubmit={(e)=>onSubmit(e)}>
                    <MDBInput name="name" style={{ borderRadius: 0, border: `1px solid #000` }} value={name} onChange={(e)=>onChange(e)} type="text" className="w-100" outline label="Your Name"/>
                    <MDBInput name="comment" style={{ borderRadius: 0, border: `1px solid #000` }} value={comment} onChange={(e)=>onChange(e)} type="textarea" rows="5" className="w-100" outline label="Your Message"/>
                    {captcha && <h6 className="red-text h6-responsive mb-3">
                        You need to verify your identity below.
                    </h6>}
                    <div className="d-block">
                        <ReCAPTCHA
                            size="compact"
                            ref={recaptchaRef}
                            sitekey="6Ld_1cEZAAAAAILqFsxD1yNO4cT5UojHRdhBCLEp"
                            onChange={(value)=>{console.log(value); setCaptcha(false);}}
                        />
                    </div>
                    <MDBBtn type="submit" className="ml-0 mt-4 text-capitalize" size="md" color="dark">
                        {btn}
                    </MDBBtn>
                </form>
            </div>
        </>
    )
}

export default AddComment
